<template>
  <div class="page-template">
    <div class="page-img">
      <div class="page-menu">
        <span class="back" @click="$router.push('/m/')">
          <van-icon name="wap-home-o" color="#ffffff" size="0.6rem" style="margin-top: 0.1rem" />
        </span>
      </div>
      <van-swipe v-if="shopInfo.carousel.length > 1" @change="swipeChange" >
        <van-swipe-item v-for="item in shopInfo.carousel" :key="item.id" @click="readImg(shopInfo.carousel,current)" >
          <img :src="item" alt="GEEK"    />
        </van-swipe-item>

        <template #indicator>
          <div class="custom-indicator">
            {{ current + 1 }}/{{ shopInfo.carousel.length }}
          </div>
        </template>
      </van-swipe>
      <img v-else :src="shopInfo.front" alt="" @click="readImg(shopInfo.front)" />
    </div>

    <div class="page-discount" v-show="discountOn">
      <img src="../../../../assets/images/discount.webp" alt="GEEK" />
      <span class="name">活动价</span>
      <span class="price"><em style="font-size: 12px">￥</em>{{ (shopInfo.price * (discount.discount / 100)).toFixed(2) }}
        <em style="font-size: 12px">起</em>
      </span>
      <span class="end-name">距结束</span>
      <span :endTime="endTime" :endText="endText" id="timer">
        <slot>{{ content }}</slot>
      </span>
    </div>

    <div class="page-title">
      <div class="name">
        <van-tag round type="danger" v-show="shopInfo.hot == 1">推荐</van-tag>
        {{ shopInfo.name }}
      </div>
      <div class="price" :style="discountOn ? 'color:#999' : ''">
        <em style="font-size: .28rem">￥</em>{{ shopInfo.price }}
        <em style="font-size: .24rem">起</em>
      </div>
    </div>

    <div class="page-parameter">
      <div class="shopstock">
        <span class="spname">选择</span>
        <h4 class="bf_h4" @click="mask = true">
          <span class="norms">共{{ shopInfo.list?shopInfo.list.length:0 }}种规格可选</span>
        </h4>
        <div class="sales">已售 {{ shopInfo.sales }}</div>
      </div>

      <div class="shopstock" v-if="shopInfo.serve.length > 0">
        <span class="spname">服务</span>
        <h4 class="bf_h4">
          <van-tag v-for="(item, index) in shopInfo.serve" :key="item" :color="color[index]">{{ item }}</van-tag>
        </h4>
      </div>
      <div class="shopstock" v-if="shopInfo.salesId">
        <span class="spname">活动</span>
        <h4 class="bf_h4" @click="discountClick">
          <van-tag round type="warning">折扣</van-tag>
          <span class="text">{{ discount.name }}</span>
        </h4>
      </div>
      <div class="shopstock" v-if="shopInfo.synopsis">
        <span class="spname">简介</span>
        <p class="synopsis">
          {{ shopInfo.synopsis }}
        </p>
      </div>
    </div>

    <div class="page-details">
      <!-- <van-tabs v-model="active">
        <van-tab title="商品详情">
          <div v-html="shopInfo.details"></div>
        </van-tab>
        <van-tab title="商品评价">
          <Empty
            :text="'该商品未开启评价'"
            v-if="shopInfo.appraise == 0"
          ></Empty>
        </van-tab>
      </van-tabs> -->
      <div class="head">
        <span class="iconfont icon-sijiaoxing1"></span>
        详情介绍
        <span class="iconfont icon-sijiaoxing1"></span>
      </div>
      <div v-html="shopInfo.details"></div>
    </div>
    <van-goods-action>
      <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24" @click="qq" />
      <van-goods-action-icon icon="logistics" text="查单" color="#ee0a24" @click="$router.push('/m/query')" />
      <!-- <van-goods-action-button
        type="warning"
        text="加入购物车"
        @click="mask = true"
      /> -->
      <van-goods-action-button type="danger" text="立即购买" @click="mask = true" />
    </van-goods-action>
    <van-popup v-model="mask" round closeable position="bottom" :style="{ height: '60%' }">
      <div class="page-buy">
        <div class="buy-front">
          <img :src="shopInfo.front" alt="GEEK"  @click="readImg(shopInfo.front)"/>
          <div class="buy-sku">
            <div class="price">
              <em style="font-size: .28rem">￥</em>{{ norms.price }}
              <span class="old-price" v-if="discountOn">
                <span style="font-size: .26rem">折后</span>
                <em style="font-size: .28rem">￥</em>{{
                  discountOn
                    ? (norms.price * (discount.discount / 100)).toFixed(2)
                    : norms.price
                }}</span>
            </div>
            <span class="stock" v-if="shopInfo.stocktype == 1">剩余 {{ norms.stock }} {{ shopInfo.unit }}</span>
            <span class="stock" v-if="shopInfo.stocktype == 2">库存{{ norms.stock > 0?'充足':'不足' }}</span>
            <div class="item">请选择规格</div>
          </div>
        </div>
        <div class="buy-body">
          <div class="buy-row">
            <div class="van-sku-row__title">规格</div>
            <span v-for="item in shopInfo.list" :key="item.id" @click="norms = item" class="van-sku-row__item"
              :class="norms.id == item.id ? 'van-sku-row__item--active' : ''">
              <!-- <div class="van-image van-sku-row__item-img">
                <img
                    src="https://b.yzcdn.cn/vant/sku/shoes-1.png"
                    class="van-image__img"
                    style="object-fit: cover"
                  />
              </div> -->
              <div class="van-sku-row__item-name">{{ item.name }}</div>
            </span>
          </div>

          <div class="buy-stock">
            <div class="title">
              购买数量
              <span class="des">({{ norms.minbuy }}{{ shopInfo.unit }}起售
                {{
                  norms.maxbuy == 0
                    ? ""
                    : "，限购" + norms.maxbuy + shopInfo.unit
                }})</span>
            </div>
            <div class="quota">
              <van-stepper v-model="count" step="1" min="1" :max="norms.maxbuy == 0 ? '9999' : norms.maxbuy" />
            </div>
            <div style="clear: both"></div>
          </div>
        </div>

        <van-goods-action>
          <!-- <van-goods-action-button type="warning" text="加入购物车" /> -->
          <van-goods-action-button type="danger" :text="norms.stock == 0 ? '库存不足' : '立即购买'"
            :disabled="norms.stock == 0 ? true : false" @click="submit" style="font-size: .28rem;" />
        </van-goods-action>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    getSingleShop,
    getDiscount
  } from "@/api/index";
  import {
    Dialog,
    Toast,
    ImagePreview
  } from "vant";
  export default {
    data() {
      return {
        shopInfo: [],
        mask: false,
        current: 0,
        count: "",
        color: window.config.serve_color,
        norms: {},
        discount: {},
        discountOn: false,
        content: "",

      };
    },
    props: {
      endTime: {
        type: String,
        default: "",
      },
      endText: {
        type: String,
        default: "活动已结束",
      },
    },
    created() {
      this._getSingleShop(this.$route.params.id);
    },

    methods: {
      qq() {
        window.open(this.$store.state.basic.help_qq,"_blank", true)
      },
      // 提交
      submit() {
        // 计算价格
        let money = this.discountOn ?
          this.norms.price * (this.discount.discount / 100) :
          this.norms.price;

        this.$store.state.order = {
          goods_id: this.shopInfo.id,
          norms_id: this.norms.id,
          count: this.count,
          money: (money * this.count).toFixed(2),
        };
        // safari 刷新丢失解决方案
        sessionStorage.setItem('order', JSON.stringify(this.$store.state.order))

        this.$router.push("/m/pay");
      },
      // 获取商品
      _getSingleShop(id) {
        getSingleShop({
          id,
        }).then((res) => {
          if (res.code == 200) {
            this.shopInfo = res.data;
            this.shopInfo.carousel.unshift(this.shopInfo.front);
            this.norms = res.data.list[0];
            if (res.data.salesId) {
              this._getDiscount(res.data.salesId);
            }
          } else {
            Toast(res.msg);
            this.$router.push("/");
          }
        });
      },

      // 获取折扣信息
      _getDiscount(id) {
        getDiscount({
          id,
        }).then((res) => {
          if (res.code == 200) {
            this.discount = res.data;

            // 转换时间戳
            let end = this.datetime_to_unix(res.data.endtime)
            let timestamp = Date.parse(new Date());
            let sta = this.datetime_to_unix(res.data.starttime)


            if (end > timestamp && sta < timestamp) {
              this.discountOn = true;
              this.countdowm(end);
            }
          }
        });
      },

      datetime_to_unix(datetime) {
        var tmp_datetime = datetime.replace(/:/g, '-');
        tmp_datetime = tmp_datetime.replace(/ /g, '-');
        var arr = tmp_datetime.split('-');
        var now = new Date(Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5]));
        return parseInt(now.getTime());
      },
      //计算时间
      countdowm(timestamp) {
        let self = this;
        let timer = setInterval(function () {
          let nowTime = new Date();
          let endTime = new Date(timestamp);
          let t = endTime.getTime() - nowTime.getTime();
          if (t > 0) {
            let day = Math.floor(t / 86400000);
            let hour = Math.floor((t / 3600000) % 24);
            let min = Math.floor((t / 60000) % 60);
            let sec = Math.floor((t / 1000) % 60);
            hour = hour < 10 ? "0" + hour : hour;
            min = min < 10 ? "0" + min : min;
            sec = sec < 10 ? "0" + sec : sec;
            let format = "";
            if (day > 0) {
              format = `${day}:${hour}:${min}:${sec}`;
            }
            if (day <= 0 && hour > 0) {
              format = `${hour}:${min}:${sec}`;
            }
            if (day <= 0 && hour <= 0) {
              format = `${min}:${sec}`;
            }
            self.content = format;
          } else {
            clearInterval(timer);
            self.content = self.endText;
            this.discountOn = false;
            self._callback();
          }
        }, 1000);
      },
      _callback() {
        if (this.callback && this.callback instanceof Function) {
          this.callback(...this);
        }
      },

      // 活动信息
      discountClick() {
        Dialog.alert({
          title: this.discount.name,
          message: '<span style="color:red">' +
            this.discount.starttime +
            "</span>" +
            "至" +
            '<span style="color:red">' +
            this.discount.endtime +
            "</span>" +
            "购买可享受" +
            '<span style="color:red">' +
            this.discount.discount/10 +
            "</span>" +
            "折优惠",
        }).then(() => {
          // on close
        });
      },
      // 轮播图序号
      swipeChange(index) {
        this.current = index;
      },
      // 预览图片
      readImg(imgs,i) {
        let arr = []
        if(imgs instanceof Array){
          arr = imgs
        }else{
          arr.push(imgs)
        }
        ImagePreview({
          images: arr,
          startPosition: i?i:0,
        });
      }
    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background-color: rgb(245, 246, 247);
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    .page-img {
      // margin-top: 1rem;
      position: relative;

      .page-menu {
        position: absolute;
        height: 1.2rem;
        width: 100%;
        z-index: 1000;
        padding: 0.2rem;

        .back {
          display: inline-block;
          background: rgba(0, 0, 0, 0.4);
          width: 0.8rem;
          height: 0.8rem;
          text-align: center;
          border-radius: 50%;
        }
      }

      .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 10px;
        font-size: 12px;
        color: #ffffff;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.3);
      }

      img {
        width: 100%;
        height: 7rem;
      }
    }

    .page-discount {
      height: 1.2rem;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }

      .name {
        position: absolute;
        left: 10px;
        top: 5px;
        font-size: .26rem;
        color: #ffffff;

      }

      .price {
        position: absolute;
        left: 10px;
        bottom: 5px;
        font-size: .4rem;
        color: #ffffff;
      }

      .end-name {
        position: absolute;
        right: 10px;
        top: 5px;
        font-style: italic;
        font-weight: 600;
        font-size: .3rem;
        color: #ffffff;
      }

      #timer {
        position: absolute;
        right: 10px;
        bottom: 5px;
        // font-style: italic;
        // font-weight: 600;
        font-size: .3rem;
        color: #ffffff;
      }
    }

    .page-title {
      min-height: 1.2rem;
      background: #ffffff;
      padding: 10px;
      position: relative;

      .name {
        width: 70%;
        font-size: .32rem;
        font-weight: 600;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;

        .van-tag {
          font-size: .24rem !important;
          line-height: .32rem !important;
        }
      }

      .price {
        position: absolute;
        right: 10px;
        bottom: 10px;
        font-size: .6rem;
        color: red;
      }
    }

    .page-parameter {
      background: #fff;
      margin: 10px 0;
      padding: 5px 10px;

      .shopstock {
        // height: 30px;
        line-height: .6rem;

        .spname {
          font-size: .28rem;
          color: #888;
        }

        .bf_h4 {
          display: inline-block;
          margin-left: .2rem;
          font-size: .28rem;
          line-height: .6rem;

          .van-tag {
            margin-right: 6px;
            font-size: .24rem !important;
            line-height: .32rem !important;
          }


          .norms {
            background: #f2f2f2;
            color: #999999;
            font-size: .28rem;
            font-weight: normal;
            border-radius: 5px;
            padding: 3px 10px;
          }

          .text {
            font-weight: normal;
          }
        }

        .synopsis {
          // display: inline-block;
          margin-left: .8rem;
          margin-top: -0.6rem;
          font-size: .28rem;
          line-height: .6rem;
        }

        .sales {
          float: right;
          color: #999999;
          font-size: .28rem;
        }
      }
    }

    .page-details {
      min-height: 400px;
      background: #fff;
      margin: 10px 0 50px 0;
      padding: 0 10px;

      .head {
        height: .8rem;
        line-height: .8rem;
        text-align: center;
        font-size: .32rem;

        .iconfont {
          font-size: .24rem;
        }
      }
    }

    .van-goods-action {
      z-index: 2000;
      height: 1rem;

      .van-goods-action-icon {
        min-width: .96rem;
        font-size: .2rem;
      }

      .van-goods-action-button {
        height: .8rem;
        font-size: .28rem;

        @{deep}.van-button__text {
          font-size: .28rem !important;
        }
      }
    }

    .page-buy {
      padding: 0.3rem;
      margin-bottom: 1rem;

      .buy-front {
        display: flex;
        // height: 2rem;
        border-bottom: 1px solid #ebedf0;

        img {
          border-radius: 4px;
          // display: inline-block;
          width: 2rem;
          height: 2rem;
          margin-right: 0.3rem;
          margin-bottom: 0.2rem;
        }

        .buy-sku {
          .price {
            margin-top: .3rem;
            // float: left;
            // display: inline-block;
            font-family: JDZhengHT-EN-Regular;
            font-size: .52rem;
            color: red;

            .old-price {
              padding: 2px 10px;
              border-radius: .3rem;
              background: red;
              color: #ffffff;
              font-size: .36rem;
              // text-decoration: line-through;
            }
          }

          .stock {
            margin-right: 8px;
            color: #969799;
            font-size: .26rem;
            line-height: .32rem;
            // margin-left: 5px;
          }

          .item {
            margin-top: 8px;
            color: #969799;
            font-size: .26rem;
            line-height: .32rem;
          }
        }
      }

      .buy-body {
        padding-top: 12px;

        .buy-row,
        .buy-stock {
          border-bottom: 1px solid #ebedf0;

          .van-sku-row__title {
            font-size: .28rem;
          }

          .van-sku-row__item {
            font-size: .28rem;
            line-height: .32rem;
          }

          .van-sku-row__item-name {
            font-size: .28rem;

          }
        }

        .buy-stock {
          padding: 12px 0;

          .title {
            float: left;
            font-size: .28rem;

            .des {
              line-height: .56rem;
              font-size: .28rem;
              color: red;
            }
          }

          .quota {
            float: right;

            @{deep}.van-stepper__input {
              width: .64rem;
              height: .56rem;
              font-size: .28rem;
            }

            @{deep}.van-stepper__minus {
              width: .56rem;
              height: .56rem;
            }

            @{deep}.van-stepper__plus {
              width: .56rem;
              height: .56rem;
            }

          }
        }
      }

      .van-goods-action {
        height: 1rem;

        .van-goods-action-button {
          height: .8rem;

        }
      }
    }
  }

  /deep/table {
    font-size: 12px;
    color: #333333;
    width: 100%;
    border-width: 1px;
    border-radius: 3px;
    overflow: hidden;
    border-color: #ffffff;
    border-collapse: collapse;

    th {
      font-size: 12px;
      background-color: #ffffff;
      border-width: 1px;
      padding: 12px;
      text-align: center !important;
      border-style: solid;
      border-color: #e6e7e9;
      text-align: left;
    }

    tr {
      background-color: #ffffff;
    }

    td {
      // font-size: 12px;
      border-width: 1px;
      padding: 12px;
      text-align: center;
      border-style: solid;
      border-color: #e6e7e9;
    }
  }
</style>